<template>
  <div
    id="kt_header"
    class="header"
  >
    <div class="container-fluid d-flex align-items-stretch justify-content-between">
      <h1 class="d-none d-md-block lh-1">
        <router-link to="/modules/forms">
          <img
            alt="Logo"
            class="h-30px logo"
            :src="formsMobileLogo"
            style="margin-top:-8px;margin-right: 30px;"
            v-if="hasRole('ROLE_FORMS_MOBILE')"
          >
        </router-link>
        <span :style="hasRole('ROLE_FORMS_MOBILE') ? 'color:#808080' : ''">{{ pageName }}</span>
      </h1>
      <div
        class="d-flex align-items-center d-lg-none ms-n3 me-1"
        title="Show aside menu"
        v-if="!hasRole('ROLE_FORMS_MOBILE')"
      >
        <div
          id="kt_aside_mobile_toggle"
          class="btn btn-icon btn-active-light-primary"
        >
          <span class="svg-icon svg-icon-2x mt-1">
            <inline-svg src="/img/navigation/menu.svg" />
          </span>
        </div>
      </div>
      <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
        <router-link
          class="d-lg-none"
          :to="hasRole('ROLE_FORMS_MOBILE') ? '/modules/forms' : '/'"
        >
          <img
            alt="Logo"
            class="header__logo"
            :src="mobileLogo"
          >
        </router-link>
      </div>
      <div class="d-flex align-items-stretch justify-content-between top-bar-nav-buttons">
        <div class="d-flex align-items-stretch flex-shrink-0">
          <Topbar />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Topbar from '@/components/header/Topbar.vue'
import {hasRole} from "@/utils/tools";
import { getClientBrandingLogo } from '@/utils/client-branding'

export default defineComponent({
  name: 'Header',
  components: { Topbar },
  props: {
    pageName: { Type: String, default: '' }
  },
  data() {
    return {
      hasRole,
      isDarkMode: false,
      themeObserver: null as MutationObserver | null
    }
  },
  computed: {
    formsMobileLogo() {
      return getClientBrandingLogo(this.isDarkMode) ?? require('@/assets/img/logo-1.svg')
    },
    mobileLogo() {
      return getClientBrandingLogo(this.isDarkMode)
        ?? (this.isDarkMode
          ? require('@/assets/img/logo-2.svg')
          : require('@/assets/img/logo-1.svg'))
    }
  },
  mounted() {
    this.checkDarkMode()
    this.observeTheme()
  },
  beforeUnmount() {
    if (this.themeObserver) {
      this.themeObserver.disconnect()
    }
  },
  methods: {
    checkDarkMode() {
      this.isDarkMode = document.body.classList.contains('dark-theme')
    },
    observeTheme() {
      this.themeObserver = new MutationObserver(() => {
        this.checkDarkMode()
      })
      this.themeObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      })
    }
  }
})
</script>

<style lang="scss" scoped>
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

.container-fluid {
  max-height: 67px;
  padding: 0 15px;
}

.header{
  &__logo{
    height:22px;
    width:auto;

    @include media-breakpoint-only(xs) {
      height: 15px;
    }
    @include media-breakpoint-only(md) {
      display: none;
    }
  }
}
</style>
